import { Expose } from 'class-transformer';

export class CreditUsagePaymentDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'order_id' })
  orderId: number;
  @Expose({ name: 'payment_status' })
  paymentStatus: string;
  @Expose({ name: 'credit_amount' })
  creditAmount: number;
  @Expose({ name: 'cash_amount' })
  cashAmount: number;
  @Expose({ name: 'credit_balance_id' })
  creditBalanceId: number;
  @Expose({ name: 'credit_card_id' })
  creditCardId: number;
}
